// vue - vuex
import Vue from 'vue'
import Vuex from 'vuex'

// types
import { UPDATE_LOADER, UPDATE_VIEW } from '@/store/types'

// modules
import userModule from '@/store/modules/user'
import warrantyModule from '@/store/modules/warranty'
import additionalInfoModule from '@/store/modules/additionalInfo'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: userModule,
    warranty: warrantyModule,
    additionalInfo: additionalInfoModule
  },
  state: {
    loader: false,
    agentView: true
  },
  mutations: {
    [UPDATE_LOADER]: function(state, payload) {
      if (typeof payload === 'boolean') {
        state.loader = payload
      }
    },
    [UPDATE_VIEW]: function(state, payload) {
      if (typeof payload === 'boolean') {
        state.agentView = payload
      }
    }
  },
  actions: {
    [UPDATE_VIEW]({ state, commit }, payload) {
      commit(UPDATE_VIEW, payload)
    }
  }
})
